/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner5 from './Banner5';
import Banner6 from './Banner6';
import Feature5 from './Feature5';
import Feature6 from './Feature6';
import Feature7 from './Feature7';
import Brand1 from './Brand1';

import {
  Banner50DataSource,
  Banner60DataSource,
  Feature50DataSource,
  Feature60DataSource,
  Feature70DataSource,
  BrandExtensive,
} from '../utils/farebox.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const onHandleClickRegister = () => {
      var link = `/contact`;
      window.location.assign(link);
    };
    const children = [
      <Banner5
        id="Banner5_0"
        key="Banner5_0"
        dataSource={Banner50DataSource}
        isMobile={this.state.isMobile}
      />,
      <Feature6
        id="Feature6_0"
        key="Feature6_0"
        dataSource={Feature60DataSource}
        isMobile={this.state.isMobile}
      />,
      <Brand1 id="Brand1_0" key="Brand1_0" dataSource={BrandExtensive} isMobile={this.state.isMobile} />,
      <Banner6
        id="Banner6_0"
        key="Banner6_0"
        dataSource={Banner60DataSource}
        isMobile={this.state.isMobile}
      />,
      <Feature7
        id="Feature7_0"
        key="Feature7_0"
        dataSource={Feature70DataSource}
        isMobile={this.state.isMobile}
      />,
      <Feature5
        id="Feature5_0"
        key="Feature5_0"
        dataSource={Feature50DataSource}
        isMobile={this.state.isMobile}
      />,
      <div className="farebox-wrapper" key="Farebox_bottom_banner">
        <div className="farebox-banner">
          <div className="farebox-banner-cover"></div>
          <div className="farebox-banner-wrapper">
            <div className="farebox-banner-text">
            Dedicated Tech, product and account support <br /> Committed to the success of our partners.
            </div>
            <div className="farebox-banner-button">
              <div onClick={onHandleClickRegister} className="ant-btn ant-btn-primary farebox-white-button">
                <span>
                  <p>Start Now</p>
                  <i className="buttonIcon"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
